import { render } from "./cell_click.vue?vue&type=template&id=37c0f2b0"
import script from "./cell_click.vue?vue&type=script&lang=ts"
export * from "./cell_click.vue?vue&type=script&lang=ts"
script.render = render

export default script